(function() {
	Vue.component('nominow-modal', {
		created: function() {
			if (!this.modal.buttoncancelcolor) {
				this.modal.buttoncancelcolor = 'is-link';
			}
			if (!this.modal.buttoncolor) {
				this.modal.buttoncolor = 'is-primary';
			}
		},
		mounted: function() {
			$('input,textarea', this.$el)
				.first()
				.focus();
			window.toggleLoader(false);
		},
		props: {
			modal: {
				type: Object,
				required: true,
				default: () => ({
					buttoncancelcolor: {
						type: String,
						default: 'is-link'
					},
					buttoncolor: {
						type: String,
						default: 'is-primary'
					}
				})
			}
		},
		watch: {
			modal: {
				handler: function(after, before) {
					// this.setPager();
					this.modal = after;
				},
				deep: true
			}
		},

		methods: {
			closemodals: function() {
				this.$parent.closemodals();
			}
		}
	});
})();
